<template>
  <!-- <div class="fix__top__right"> -->
  <div class="w-100">
    <p
      class="d-flex align-items-center grey-on-hover mb-0 py-1"
      key="nm-closed"
      @click="openNotifications"
      style="
        white-space: nowrap;
        flex-shrink: 0;
        text-overflow: clip;
        overflow-x: hidden;
      "
    >
      <b-iconstack font-scale="1.3" class="point ml-1">
        <b-icon stacked icon="circle-fill" variant="white" scale="0.6"></b-icon>
        <b-icon stacked icon="bell-fill" scale="0.8" variant="white"></b-icon>
        <b-icon stacked icon="bell" scale="0.8" variant=""></b-icon>
        <b-icon stacked icon="circle" scale="1.05" variant=""></b-icon>
      </b-iconstack>
      <b-badge
        v-show="msgCount > 0"
        class="align-self-start notification__count"
        variant="danger"
        >{{ msgCount }}
      </b-badge>
      <span class="mb-0 ml-2 point">{{ $t('NotificationCenter.title') }}</span>
    </p>
    <transition-group name="slideside" mode="out-in">
      <b-row
        v-if="isOpen"
        class="w-100 col-12 align-content-start px-0"
        key="nm-opened"
        style="
          z-index: 99999;
          position: fixed;
          top: 0px;
          left: 0px;
          height: 100vh;
        "
      >
        <b-col
          class="px-0 col-12 col-md-7 col-lg-6 col-lgx-5 col-xl-4 bg-white h-100 general_border"
        >
          <b-row
            class="px-0 d-flex justify-content-between align-items-start mt-4 mt-2 px-4 mx-4"
          >
            <h1>{{ $t('NotificationCenter.title') }} {{ msgCountText }}</h1>
            <b-icon
              class="point mr-2"
              variant="secondary"
              icon="x"
              font-scale="3"
              @click="isOpen = false"
            ></b-icon>
          </b-row>
          <b-col class="px-3 mt-3" style="height: 95vh; overflow-y: scroll">
            <b-col
              v-for="(msg, ind) in messages"
              :key="ind"
              class="d-flex align-items-center my-2 text-left bg-line-grey general_border border-secondary py-3"
            >
              <b-icon
                icon="bell"
                variant="secondary mr-3"
                font-scale="3"
              ></b-icon>
              <div>
                <h6 class="font-weight-bolder">
                  {{ msg.title }}
                </h6>
                <p class="text-font-grey mb-0">{{ msg.body }}</p>
              </div>
            </b-col>
            <b-col
              v-for="(msg, ind) in readMessages"
              :key="'r-' + ind"
              class="my-2 d-flex align-items-center text-left border general_border border-secondary shadow_2 py-3"
            >
              <b-icon
                icon="bell"
                variant="secondary mr-3"
                font-scale="3"
              ></b-icon>
              <div>
                <h6 class="font-weight-bolder">
                  {{ msg.title }}
                </h6>
                <p class="text-font-grey mb-0">{{ msg.body }}</p>
                <p class="text-font-grey mb-0" v-if="msg.extraData">
                  {{ msg.extraData }}
                </p>
              </div>
            </b-col>
            <template v-if="noTokenMsg">
              <b-col key="empty-list" class="my-2 text-left pt-3">
                <h5 class="text-secondary"></h5>
                <p class="text-font-grey">
                  {{ $t('NotificationCenter.browserPermission') }}
                </p>
              </b-col>
            </template>
            <template v-else-if="msgCount == 0 && readMessages.length == 0">
              <b-col key="empty-list" class="my-2 text-left pt-3">
                <p class="text-font-grey">{{ $t('NotificationCenter.noNotifications') }}</p>
              </b-col>
            </template>
          </b-col>
        </b-col>
        <b-col class="d-none d-md-block bg__g h-100" @click="isOpen = false">
        </b-col>
      </b-row>
    </transition-group>
  </div>

  <!-- </div> -->
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getAuth, onAuthStateChanged, getRedirectResult } from "firebase/auth";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { cittadinoService } from "@/_services";
export default {
  name: "NotificationCenter",
  data() {
    return {
      token: null,
      messages: [],
      readMessages: [],
      isOpen: false,
      noTokenMsg: false,
      attempts: 0,
      notificationLogCounter: 0, // Contatore per tracking duplicati
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState("utente", ["status", "user"]),
    msgCount: function () {
      const count = this.messages.length;
      return count;
    },
    msgCountText: function () {
      const text = this.msgCount > 0 ? ` (${this.msgCount})` : "";
      return text;
    },
  },
  watch: {
    token: function (now, prev) {
      if (now) {
        this.storeToken();
      }
    },
    messages: {
      handler: function(newMessages, oldMessages) {
      },
      deep: true
    },
    readMessages: {
      handler: function(newMessages, oldMessages) {
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    openNotifications() {      
      this.isOpen = true;
      var self = this;
      setTimeout(function () {        
        var prev = self.readMessages;
        self.readMessages = self.messages.concat(prev);
        self.messages = [];
      }, 1000);
    },
    firebaseAuth() {
      const auth = getAuth(this.$root.firebaseApp);
      onAuthStateChanged(auth, (user) => {
      });
    },
    storeToken() {
      var form = {
        token: this.token,
        client: "web",
      };
      
      var self = this;
      cittadinoService
        .storeFirebaseToken(form)
        .then(function (res) {
        })
        .catch(function (err) {
          console.error("💾 [storeToken] Error storing token:", err);
          self.initPushWithTimeout();
        });
    },
    async messagingInit() {
      var self = this;
      try {
        // Verifica supporto Service Worker
        if (!('serviceWorker' in navigator)) {
          self.noTokenMsg = true;
          return;
        }
        
        // Scope del service worker
        const scopePath = "/" + process.env.VUE_APP_SCOPE + "/";
        const registration = await navigator.serviceWorker.getRegistration(scopePath);
        
        if (!registration) {
          const allRegistrations = await navigator.serviceWorker.getRegistrations();
          self.noTokenMsg = true;
          return;
        }
        
        if (registration.active && !navigator.serviceWorker.controller) {

          try {
            await registration.update();
          } catch (updateErr) {
          }

          const controllerPromise = new Promise((resolve) => {
            if (navigator.serviceWorker.controller) {
              resolve(navigator.serviceWorker.controller);
              return;
            }
            navigator.serviceWorker.addEventListener(
              'controllerchange',
              () => {
                if (navigator.serviceWorker.controller) {
                  resolve(navigator.serviceWorker.controller);
                }
              },
              { once: true }
            );
          });

          const readyPromise = navigator.serviceWorker.ready
            .then((readyReg) => {
              return readyReg.active || navigator.serviceWorker.controller;
            })
            .catch(() => null);

          const timeoutPromise = new Promise((resolve) => setTimeout(resolve, 5000));

          const controller = await Promise.race([
            controllerPromise,
            readyPromise,
            timeoutPromise,
          ]);
        }
        
        // Verifica che il SW sia effettivamente attivo
        if (!registration.active) {
          console.error("🚀 [messagingInit] Service Worker is NOT active");
          self.noTokenMsg = true;
          return;
        }

        // Inizializza Firebase Messaging
        const messaging = getMessaging(this.$root.firebaseApp);
        
        var vapkey = process.env.VUE_APP_FBS_VAPIDKEY;
        
        if (!vapkey) {
          console.error("🚀 [messagingInit] No VAPID key found");
          self.noTokenMsg = true;
          return;
        }
        
        getToken(messaging, {
          vapidKey: vapkey,
          serviceWorkerRegistration: registration,
        })
          .then((currentToken) => {
            if (currentToken) {
              self.token = currentToken;
              self.noTokenMsg = false;
            } else {
              console.warn("🚀 [messagingInit] No token obtained (permission denied?)");
              self.noTokenMsg = true;
            }
          })
          .catch((err) => {
            console.error("🚀 [messagingInit] Error retrieving token:", err);
            self.noTokenMsg = true;
          });

        // Handler per messaggi in foreground (quando l'app è aperta)
        onMessage(messaging, (payload) => {
          self.notificationLogCounter++;
        
          if (payload.notification) {
            self.addMessage(payload.notification);
          } else if (payload.data) {
            self.addMessage(payload.data);
          }
        });
      } catch (err) {
        console.error("🚀 [messagingInit] Exception during initialization:", err);
        console.error("🚀 [messagingInit] Error stack:", err.stack);
        self.noTokenMsg = true;
      }
    },
    addMessage(data) {
      this.notificationLogCounter++;
      this.messages.splice(0, 0, data);

      this.$bvToast.toast(data.body, {
        title: data.title,
        solid: true,
        variant: "primary",
      });
      // this.infoAlert("Nuova notifica");
    },
    initPushWithTimeout() {
      
      if (this.attempts > 3) {
        console.warn("⏳ [initPushWithTimeout] Max attempts reached (3), stopping");
        return false;
      }
      
      var self = this;
      setTimeout(function () {
        isSupported().then((supported) => {
          if (supported) {
            self.attempts++;
            self.messagingInit();
          } else {
            console.warn("⏳ [initPushWithTimeout timeout] Firebase Messaging NOT supported");
          }
        });
      }, 3000);
    },
  },
  created() {
    isSupported().then((supported) => {
      if (supported) {
        this.firebaseAuth();
      } else {
        console.warn("🎬 [created] Firebase Messaging NOT supported, skipping auth");
      }
    });
  },
  mounted() {    
    this.initPushWithTimeout();
    
    // navigator.serviceWorker.addEventListener("message", (event) => {
    //   self.notificationLogCounter++;
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Message received from Service Worker");
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] event.data:", JSON.stringify(event.data, null, 2));
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Stack trace:", new Error().stack);
    //   
    //   var payload = event.data;
    //   if (event.data.data) {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Using event.data.data");
    //     payload = event.data.data;
    //   } else if (event.data.notification) {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Using event.data.notification");
    //     payload = event.data.notification;
    //   }
    //   
    //   console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Final payload:", JSON.stringify(payload, null, 2));
    //   
    //   // Verifica che il payload contenga dati validi prima di mostrare la notifica
    //   if (payload && (payload.title || payload.body)) {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Calling addMessage");
    //     this.addMessage(payload);
    //   } else {
    //     console.log("📨 [SW Listener #" + self.notificationLogCounter + "] Payload invalid, NOT calling addMessage");
    //   }
    // });
  },
};
</script>
<style>
.fix__top__right {
  position: absolute;
  top: 1rem;
  /* right: 1rem; */
  z-index: 999999;
}

.right__1 {
  right: -2rem;
}

.right__0 {
  right: 0;
  height: calc(100% - 2rem);
  box-shadow: -2px 10px 3px #9f9f9f36;
  overflow-y: scroll;
}

.notification__count {
  margin-left: -0.5rem;
  margin-bottom: 1rem;
}

.grey-on-hover:hover {
  color: #575757;
  font-weight: 500;
}
</style>
